// extracted by mini-css-extract-plugin
export default {"option":"OptionsConfig_option__7R4B4","icon":"OptionsConfig_icon__QjzM+","input":"OptionsConfig_input__myqer"};